import React from 'react'

export default function ContactMailIcon() {
  return (
    <svg
    width="31"
    height="28"
    viewBox="0 0 31 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
 >
    <path
       fillRule="evenodd"
       clipRule="evenodd"
       d="M23.1897 0.214844C25.2012 0.214844 27.1362 1.00984 28.5597 2.43634C29.9847 3.85984 30.7812 5.77984 30.7812 7.78984V19.6398C30.7812 23.8248 27.3762 27.2148 23.1897 27.2148H8.37125C4.18475 27.2148 0.78125 23.8248 0.78125 19.6398V7.78984C0.78125 3.60484 4.16975 0.214844 8.37125 0.214844H23.1897ZM25.5763 10.0248L25.6963 9.90484C26.0548 9.46984 26.0547 8.83984 25.6797 8.40484C25.4712 8.18134 25.1847 8.04484 24.8862 8.01484C24.5713 7.99834 24.2712 8.10484 24.0448 8.31484L17.2812 13.7148C16.4113 14.4363 15.1648 14.4363 14.2812 13.7148L7.53125 8.31484C7.06475 7.96984 6.41975 8.01484 6.03125 8.41984C5.62625 8.82484 5.58125 9.46984 5.92475 9.91984L6.12125 10.1148L12.9462 15.4398C13.7863 16.0998 14.8048 16.4598 15.8713 16.4598C16.9347 16.4598 17.9712 16.0998 18.8097 15.4398L25.5763 10.0248Z"
       fill="#F1ECDC"
    />
 </svg>
  )
}
